/**
 * Redirect-mode entry point.
 *
 * Mounted at register.tourneynation.com. Rendered as a full-page
 * registration surface with persistent organizer attribution and a
 * return-to-organizer CTA on completion.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import './styles/theme-tokens.css';
import './styles/global.css';
import './styles/skin-next.css';
import { maybeInstallStudioBridge } from './styles/studio-bridge';

maybeInstallStudioBridge();

// Studio iframes the production build under /preview/, so the router
// needs that as its basename or every route misses (the iframe lands
// on /preview but path="/" only matches a literal "/"). In production
// the app is served at the subdomain root, so no basename.
const studioMode = new URLSearchParams(window.location.search).get('studio') === '1';
const basename = studioMode ? '/preview' : undefined;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <App displayMode="redirect" />
    </BrowserRouter>
  </React.StrictMode>,
);
